module.exports = __webpack_public_path__ + "media/images/emblems/Penthereaz-coat_of_arms-c5332be41593aff6c290cb01435571ba.svg";